import React, { useEffect } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { SIMULATOR_LIST_PATH, SIMULATOR_RESULTS_PATH } from "./simulatorRoutes";

type RouteParams = { backtestId: string };

/** Legacy path — redirects to the unified results page. */
export default function SimulatorSavedRunPage(): JSX.Element | null {
  const history = useHistory();
  const location = useLocation();
  const { backtestId } = useParams<RouteParams>();
  const id = backtestId?.trim() ?? "";

  useEffect(() => {
    if (!id) {
      history.replace(SIMULATOR_LIST_PATH);
      return;
    }
    // Preserve hub nav state so results breadcrumbs stay Tessera › Workspace › …
    history.replace({
      pathname: SIMULATOR_RESULTS_PATH,
      search: `?backtest=${encodeURIComponent(id)}`,
      state: location.state,
    });
  }, [history, id, location.state]);

  return null;
}
